import { Navigate } from 'react-router-dom';
import { useUser } from './auth';

export const LoggedIn = () => {
  const user = useUser();
  if (user) return <Navigate to="/dashboard" replace />;
};
